import { SmallBarComparison } from "../SmallBarComparison/SmallBarComparison";
import { useWindowSize } from "./SolarVsGridBars.hooks";
import { useTheme, darken } from "@material-ui/core";
import React from "react";

export const SolarVsGridBars = ({ solarGenerated, gridConsumed }) => {
  const [width] = useWindowSize();
  const theme = useTheme();

  const item1 = {
    value: solarGenerated || 0,
    name: "Solar",
    // color: theme.palette.dataKeys?.solarGenerated || "#24A21A",
    color: theme.palette.common.white,
    dataKey: "solarGenerated",
  };

  const item2 = {
    value: gridConsumed || 0,
    name: "Grid",
    // color: theme.palette.dataKeys?.gridConsumed || "#808080",
    color: darken(theme.palette.common.white, 0.2),
    dataKey: "gridConsumed",
  };

  if (width < 1000) {
    return null;
  }

  return <SmallBarComparison item1={item1} item2={item2} />;
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/ComparisonBars/SolarVsGridBars/SolarVsGridBars.js